// E-2 — DiagramNode.tsx: renders one scene point with its block art + CAPS
// leader-line label. Pure render from the scene graph — never re-derives math.
import type { ScenePoint } from '../../utils/sceneGraph';
import { blockArt } from './blockArt';

export interface DiagramNodeProps {
  point: ScenePoint;
  /** px transform: scene ft → viewport px (single pxPerFt factor + letterbox offset) */
  toPx: (pt: { x: number; y: number }) => { x: number; y: number };
  label?: string;
  labelAnchor?: 'start' | 'end' | 'middle';
}

export function DiagramNode({ point, toPx, label, labelAnchor = 'start' }: DiagramNodeProps) {
  const art = blockArt(point.kind);
  const { x, y } = toPx(point.pt);
  return (
    <g data-node={point.id} data-kind={point.kind} className="diagram-node">
      {art.paths.map((d, i) => (
        <path key={i} d={d} transform={`translate(${x} ${y})`} fill="none" stroke="black" strokeWidth={1.25} />
      ))}
      {label && (
        <text
          x={x + art.half + 6}
          y={y - art.half - 4}
          textAnchor={labelAnchor}
          fontSize={9}
          fontFamily="monospace"
          fill="black"
          paintOrder="stroke"
          stroke="#ffffff"
          strokeWidth={2.5}
          style={{ letterSpacing: '0.5px' }}
        >
          {label.toUpperCase()}
        </text>
      )}
    </g>
  );
}
